import type { JwtPayload, TokenSet } from './types';

// Access/id tokens — in-memory only, never persisted
let currentTokens: TokenSet | null = null;

export function setTokens(tokens: TokenSet): void {
  currentTokens = tokens;
}

export function getTokens(): TokenSet | null {
  return currentTokens;
}

export function clearTokens(): void {
  currentTokens = null;
}

export function getAccessToken(): string | null {
  if (!currentTokens) return null;
  if (isTokenExpired(currentTokens.expiresAt)) return null;
  return currentTokens.accessToken;
}

export function decodeJwt(token: string): JwtPayload {
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('Invalid JWT format');
  }
  const payload = parts[1];
  const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
  return JSON.parse(decoded) as JwtPayload;
}

export function isTokenExpired(
  expiresAt: number,
  bufferSeconds = 60,
): boolean {
  return Date.now() / 1000 >= expiresAt - bufferSeconds;
}

export function parseTokenResponse(data: {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token?: string;
  token_type: string;
}): TokenSet {
  return {
    accessToken: data.access_token,
    expiresAt: Math.floor(Date.now() / 1000) + data.expires_in,
    idToken: data.id_token,
    refreshToken: data.refresh_token,
  };
}
